module.exports = __webpack_public_path__ + "img/130010.6574a2e4.png";